export default __webpack_public_path__ + "static/media/wonSchool.a88e5414.svg";